module.exports = __webpack_public_path__ + "static/media/gg-yellow.dd40d031.svg";